import {
  DatepickerFormField,
  SelectFormField,
  TextFormField,
} from 'components/DynamicFormFields';
import { useFormContext, useWatch } from 'react-hook-form';
import { t } from 'i18next';
import { TextField } from '@mui/material';
import {
  CONSENT_STATUS_OPTIONS,
  EXPIRES_OPTIONS,
  HOW_OBTAINED_OPTIONS,
  OBTAINED_BY_OPTIONS,
  WHO_CONSENTED_OPTIONS,
  getConsentTypeOptions,
} from '../schemas';

interface IConsentEntryProps {
  index: number;
  programName: string;
  disabled?: boolean;
}

const label = (key: string) =>
  t(`patient.detailsCard.editPatientProgram.consent.fields.${key}`);

export const ConsentEntry = ({
  index,
  programName,
  disabled = false,
}: IConsentEntryProps) => {
  const { control } = useFormContext();
  const whoConsented = useWatch({
    control,
    name: `consents.${index}.who_consented`,
  });

  const consentTypeOptions = getConsentTypeOptions(programName);
  const consentTypeLabel = consentTypeOptions[0]?.label ?? '';

  return (
    <>
      <TextField
        label={label('consentType')}
        value={consentTypeLabel}
        disabled={true}
        fullWidth
      />
      <SelectFormField
        name={`consents.${index}.how_obtained`}
        label={label('howObtained')}
        disabled={disabled}
        options={HOW_OBTAINED_OPTIONS}
      />
      <DatepickerFormField
        name={`consents.${index}.date_obtained`}
        label={label('dateObtained')}
        disabled={disabled}
        optional={false}
        disable_future
      />
      <SelectFormField
        name={`consents.${index}.status`}
        label={label('status')}
        disabled={disabled}
        options={CONSENT_STATUS_OPTIONS}
      />
      <SelectFormField
        name={`consents.${index}.obtained_by`}
        label={label('obtainedBy')}
        disabled={disabled}
        options={OBTAINED_BY_OPTIONS}
      />
      <SelectFormField
        name={`consents.${index}.who_consented`}
        label={label('whoConsented')}
        disabled={disabled}
        options={WHO_CONSENTED_OPTIONS}
      />
      {whoConsented === 'Other' && (
        <TextFormField
          name={`consents.${index}.other_specify`}
          label={label('otherSpecify')}
          disabled={disabled}
        />
      )}
      <SelectFormField
        name={`consents.${index}.expires`}
        label={label('expires')}
        disabled={disabled}
        options={EXPIRES_OPTIONS}
      />
    </>
  );
};
